export default {
      id: "tooltip-plus-usage",
      viewBox: "0 0 37 37",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#tooltip-plus",
      toString: function () {
        return this.url;
      }
    }